import { OrderType, ProductCart } from '../types/cart';

type CheckoutFormData = {
  products: ProductCart[];
  orderType: OrderType;
  total: string;
  name?: string;
  address?: string;
  addressNumber?: string;
  neighborhood?: string;
  complement?: string;
  observation?: string;
}

interface WhatsAppTemplateAPI {
  build: (data: CheckoutFormData) => string
}

const formatPrice = (price: number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(price);
};

const buildProductDetails = (product: ProductCart) => {
  const {name, quantity, price} = product;
  const total = quantity * price;

  return `${name} x ${quantity} = ${formatPrice(total)}`;
};

const buildAddress = (data: CheckoutFormData) => {
  const { address, addressNumber, neighborhood, complement } = data;
  // return `${address} - ${addressNumber} - ${neighborhood} - ${complement}\n`;
  return `
${address}
N°: ${addressNumber}
Bairro: ${neighborhood}
Complemento: ${complement ? complement : ''}  
  `;
}

export const WhatsAppTemplate = (): WhatsAppTemplateAPI => ({
  build: (data) => {
    const isDelivery = data.orderType === OrderType.Entrega;
    const orderDate = new Date().toLocaleDateString('pt-BR');

    const template = `
Pedido: ${orderDate}
--------------------------------------------------------
Forma do pedido: ${isDelivery ? 'Entrega' : 'Retirada'}
${isDelivery ? `
--------------------------------------------------------
Nome: ${data.name}
Endereço: ${buildAddress(data)}
` : ''}
--------------------------------------------------------
${data.observation ? `
--------------------------------------------------------
Observação: ${data.observation}
` : ''}
${data.products.map(buildProductDetails).join('\n')}
--------------------------------------------------------
Total do pedido => ${formatPrice(Number(data.total))}
`;

    return template;
  },
});
